
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { BuyChannelSource } from '@/Sources';

  @Component({
    name: 'buy-channel-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class BuyChannelDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Channel' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ default: '' }) public errorText!: string;

    public source: BuyChannelSource = new BuyChannelSource();

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
